<template>
  <div class="home-container">
    <div class="home-content">
      <!-- 搜索 -->
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="小区名称" prop="name" style="width: 80%">
                <el-input
                  v-model="searchForm.name"
                  placeholder="请输入小区名称"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="margin: 20px">
        <el-button
          size="small"
          plain
          type="primary"
          icon="el-icon-plus"
          @click="addUser"
          style="width: 90px"
          >新增</el-button
        >
        <el-button
          size="small"
          @click="onLoad(1)"
          type="primary"
          icon="el-icon-search"
          style="width: 90px"
          >搜索</el-button
        >
        <el-button
          size="small"
          @click="restSearch"
          type="danger"
          style="width: 90px"
          >重置</el-button
        >
      </div>

      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="name" label="小区名称" align="center">
          <template slot-scope="scope">
            <a @click="see(scope.row)">{{ scope.row.name }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="小区地址" align="center">
        </el-table-column>
        <el-table-column prop="province" label="省级行政编码" align="center">
        </el-table-column>
        <el-table-column prop="city" label="市级行政编码" align="center">
        </el-table-column>
        <el-table-column prop="longitude" label="经度" align="center">
        </el-table-column>
        <el-table-column prop="latitude" label="纬度" align="center">
        </el-table-column>
        <el-table-column prop="detail" label="小区描述" align="center">
        </el-table-column>
        <!-- <el-table-column prop="type" label="小区类型" align="center" :formatter="typeList">
        </el-table-column> -->
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="updata(scope.row)"
              >修改</el-button
            >
            <el-button @click="del(scope.row)" type="text" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新增模态框 -->
      <el-dialog
        :title="modalTitle"
        :visible.sync="isAddModal"
        width="50%"
        @close="close()"
        :close-on-click-modal="false"
      >
        <el-form
          ref="form"
          :model="addData"
          label-width="110px"
          :rules="addDataRules"
          label-position="center"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="小区名称" prop="name">
                <el-input
                  v-model="addData.name"
                  :disabled="disabled"
                  placeholder="请输入小区名称"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="小区地址" prop="address">
                <el-input
                  v-model="addData.address"
                  :disabled="disabled"
                  placeholder="请输入小区地址"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="小程序id" label-width="100px" prop="appId">
                <el-input
                  v-model="addData.appId"
                  :disabled="disabled"
                  placeholder="请输入小程序appid"
                ></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>
          <!-- <el-row>
            <el-col :span="12">
              <el-form-item
                label="小程序密钥"
                label-width="100px"
                prop="secret"
              >
                <el-input
                  :disabled="disabled"
                  v-model="addData.secret"
                  placeholder="请输入小程序密钥"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="公众号appid"
                label-width="100px"
                prop="gzhAppId"
              >
                <el-input
                  :disabled="disabled"
                  v-model="addData.gzhAppId"
                  placeholder="请输入公众号appid"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="公众号secret"
                label-width="100px"
                prop="gzhSecret"
              >
                <el-input
                  :disabled="disabled"
                  v-model="addData.gzhSecret"
                  placeholder="请输入公众号secret"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="商户号id" label-width="100px" prop="mchId">
                <el-input
                  :disabled="disabled"
                  v-model="addData.mchId"
                  placeholder="请输入商户号id"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="	商户key" label-width="100px" prop="mchKey">
                <el-input
                  :disabled="disabled"
                  v-model="addData.mchKey"
                  placeholder="请输入商户key"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="证书序列号"
                label-width="100px"
                prop="serialNo"
              >
                <el-input
                  :disabled="disabled"
                  v-model="addData.serialNo"
                  placeholder="请输入证书序列号"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="证书cert路口"
                label-width="100px"
                prop="sslCertFile"
              >
                <el-input
                  :disabled="disabled"
                  v-model="addData.sslCertFile"
                  placeholder="请输入证书cert路口"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="证书key路径"
                label-width="100px"
                prop="sslKeyFile"
              >
                <el-input
                  :disabled="disabled"
                  v-model="addData.sslKeyFile"
                  placeholder="请输入证书key路径"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="v3支付密钥"
                label-width="100px"
                prop="v3Secret"
              >
                <el-input
                  :disabled="disabled"
                  v-model="addData.v3Secret"
                  placeholder="请输入v3支付密钥"
                ></el-input>
              </el-form-item>
            </el-col>
           <el-col :span="12">
              <el-form-item label="小区类型" label-width="100px" prop="detail">
                <el-select clearable filterable v-model="addData.type" placeholder="请选择">
                  <el-option
                    v-for="item in parkList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col> 
          </el-row>-->
          <el-row>
            <el-col :span="12">
              <el-form-item label="省级行政编码" prop="province">
                <el-input
                  v-model="addData.province"
                  :disabled="disabled"
                  placeholder="请输入省级行政编码"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="市级行政编码" prop="city">
                <el-input
                  v-model="addData.city"
                  :disabled="disabled"
                  placeholder="请输入市级行政编码"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="经度" prop="longitude">
                <el-input
                  v-model="addData.longitude"
                  :disabled="disabled"
                  placeholder="请输入经度"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="纬度" prop="latitude">
                <el-input
                  v-model="addData.latitude"
                  :disabled="disabled"
                  placeholder="请输入纬度"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="小区描述" prop="detail">
                <el-input
                  :disabled="disabled"
                  v-model="addData.detail"
                  type="textarea"
                  placeholder="请输入小区描述"
                  maxlength="255"
                  show-word-limit
                  :rows="5"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="close()">取 消</el-button>
          <el-button type="primary" @click="submit" :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import AES from "@/utils/aes";
import upload from "../../components/upload";
export default {
  components: {
    upload,
  },
  data() {
    return {
      searchForm: {
        name: "",
      },
      modalTitle: "新增",
      isShowLabel: true, //修改的时候为false  无法修改账号密码
      roleList: [], //角色信息
      tableData: [],
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      addData: {
        secret: "",
        appId: "",
        name: "",
        detail: "",
        gzhAppId: "",
        gzhSecret: "",
        id: "",
        mchId: "",
        mchKey: "",
        serialNo: "",
        sslCertFile: "",
        sslKeyFile: "",
        v3Secret: "",
        type:'',
        address:'',
        province:'',
        city:'',
        longitude:'',
        latitude:'',
      },
      keySecret: "",
      addDataRules: {
        // appId: [{ required: true, message: "请输入小程序id", trigger: "blur" }],
        name: [{ required: true, message: "请输入小区名称", trigger: "blur" }],
        secret: [{ required: true, message: "请输入小程序密钥", trigger: "blur" }],
        address: [{ required: true, message: "请输入小区地址", trigger: "blur" }],
        province: [{ required: true, message: "请输入省级行政编码", trigger: "blur" }],
        city: [{ required: true, message: "请输入市级行政编码", trigger: "blur" }],
        longitude: [{ required: true, message: "请输入经度", trigger: "blur" }],
        latitude: [{ required: true, message: "请输入纬度", trigger: "blur" }],
      },
      isShowloading: false, //数据加载
      isAddModal: false, //新增模态框
      btnLoading: false, //提交按钮加载
      disabled: false,
      parkList: [
        {
          value: 1,
          label: "机关小区",
        },
        {
          value: 2,
          label: "重要院落",
        },
        {
          value: 3,
          label: "行政中心",
        },
        {
          value: 4,
          label: "外接项目",
        },
        {
          value: 5,
          label: "其他",
        },
      ],
    };
  },
  mounted() {
    this.onLoad();
    this.$Apis.getCharacterList().then((res) => {
      if (res.code == 200) {
        let { list } = res.data;
        this.roleList = list;
      }
    });
  },
  methods: {
    typeList(row){
      if(row.type == 1){
        return "机关小区"
      }else if(row.type == 2){
        return "重要院落"
      }else if(row.type == 3){
        return "行政中心"
      }else if(row.type == 4){
        return "外接项目"
      }else if(row.type == 5){
        return "其他"
      }
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    //   删除用户
    del(row) {
      this.$confirm("您确定要删除该用户吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$Apis.villageDel({ id: row.id }).then((res) => {
          if (res.code == 200) {
            this.$message.success("删除成功");
            this.onLoad();
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },
    // 修改用户状态
    updateLockStates(row) {
      this.$Apis
        .updateLockStates({
          id: row.id,
          lockStatus: row.lockStatus == true ? "2" : "1",
        })
        .then((res) => {
          if (res.code == 200) {
            this.onLoad();
            this.$message.success("操作成功");
          } else {
            this.$message.warning(res.msg);
          }
        });
    },
    // 新增用户
    addUser() {
      this.modalTitle = "新增";
      this.isAddModal = true;
      
    },
    see(row) {
      this.modalTitle = "查看";
      this.isAddModal = true;
      this.disabled = true;
      this.addData = JSON.parse(JSON.stringify(row));
    },
    close(){ 
      this.$refs["form"].resetFields();
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.isAddModal = false;
    },
    updata(row) {
      this.modalTitle = "修改";
      this.isAddModal = true;
      this.disabled = false;
      this.addData = JSON.parse(JSON.stringify(row));
      if(this.addData.type == 0){
        this.addData.type = "";
      }
    },
    submit() {
      if (this.disabled) {
        this.isAddModal = false;
        return;
      }
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          let data = {
            appId: this.addData.appId ? AES.encrypt(this.addData.appId, this.keySecret) : undefined,
            name: this.addData.name,
            detail: this.addData.detail,
            address: this.addData.address,
            province: this.addData.province,
            city: this.addData.city,
            longitude: this.addData.longitude,
            latitude: this.addData.latitude,
            gzhAppId: this.addData.gzhAppId ? AES.encrypt(this.addData.gzhAppId, this.keySecret) : undefined,
            gzhSecret: this.addData.gzhSecret ? AES.encrypt(this.addData.gzhSecret, this.keySecret) : undefined,
            
            mchId: this.addData.mchId ? AES.encrypt(this.addData.mchId, this.keySecret) : undefined,
            mchKey: this.addData.mchKey ? AES.encrypt(this.addData.mchKey, this.keySecret) : undefined,
            serialNo: this.addData.serialNo ? AES.encrypt(this.addData.serialNo, this.keySecret) : undefined,
            sslCertFile: this.addData.sslCertFile ? AES.encrypt(this.addData.sslCertFile, this.keySecret) : undefined,
            sslKeyFile: this.addData.sslKeyFile ? AES.encrypt(this.addData.sslKeyFile, this.keySecret) : undefined,
            v3Secret: this.addData.v3Secret ? AES.encrypt(this.addData.v3Secret, this.keySecret) : undefined,
            secret: this.addData.secret ? AES.encrypt(this.addData.secret, this.keySecret) : undefined,
            type:this.addData.type
          };
          if(this.addData.id){
            data.id = this.addData.id
          }
          this.$Apis.villageUpdata(data).then((res) => {
            this.btnLoading = false;
            if (res.code == 200) {
              close()
              this.isAddModal = false;
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },

    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    onLoad(ind) {
      //   this.isShowloading = true;
      this.currentPage = ind == 1 ? 1 : this.currentPage;
      let page = {
        current: this.currentPage,
        size: this.pageSize,
        ...this.searchForm,
      };
      this.$Apis.villageList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          // list.forEach((item) => {
          //   (item.appId = AES.decrypt(item.appId, this.keySecret)),
          //     (item.name = item.name),
          //     (item.detail = item.detail),
          //     (item.gzhAppId = AES.decrypt(item.gzhAppId, this.keySecret)),
          //     (item.gzhSecret = AES.decrypt(item.gzhSecret, this.keySecret)),
          //     (item.id = item.id),
          //     (item.mchId = AES.decrypt(item.mchId, this.keySecret)),
          //     (item.mchKey = AES.decrypt(item.mchKey, this.keySecret)),
          //     (item.serialNo = AES.decrypt(item.serialNo, this.keySecret)),
          //     (item.sslCertFile = AES.decrypt(
          //       item.sslCertFile,
          //       this.keySecret
          //     )),
          //     (item.sslKeyFile = AES.decrypt(item.sslKeyFile, this.keySecret)),
          //     (item.v3Secret = AES.decrypt(item.v3Secret, this.keySecret)),
          //     (item.secret = AES.decrypt(item.secret, this.keySecret));
          // });
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
  },
};
</script>

<style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}
</style>    